import { cod } from "./cod";

export const calculations = { cod };
